import { render, staticRenderFns } from "./OrgaUnits.vue?vue&type=template&id=4493b42a&scoped=true&"
import script from "./OrgaUnits.vue?vue&type=script&lang=js&"
export * from "./OrgaUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493b42a",
  null
  
)

export default component.exports